import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const ButtonMeta: ComponentMeta = {
  componentName: "Button",
  package: "@mijadesign/web",
  title: "按钮",
  description: "按钮用于开始一个即时操作",
  category: ComponentCategory.GENERAL,
  visibleInComponentPanel: true,
  icon: "BorderOutlined",
  eventSources: [
    {
      name: "click",
      label: "点击",
      trigger: "dom",
    },
  ],
  designToken: {
    fields: [
      { name: "borderRadius", label: "圆角", type: "number", min: 0, max: 48 },
      {
        name: "controlHeight",
        label: "高度",
        type: "number",
        min: 16,
        max: 80,
      },
      { name: "colorPrimary", label: "主色", type: "color" },
      { name: "primaryShadow", label: "主按钮阴影", type: "string" },
      { name: "defaultShadow", label: "默认阴影", type: "string" },
    ],
  },
  props: [
    {
      name: "type",
      label: "按钮类型",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "默认", value: "default" },
        { label: "主按钮", value: "primary" },
        { label: "虚线", value: "dashed" },
        { label: "文本", value: "text" },
        { label: "链接", value: "link" },
      ],
      group: "基础",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "基础",
    },
    {
      name: "children",
      label: "按钮文本",
      type: PropType.STRING,
      bindable: true,
      bindSources: ["state", "record"],
      defaultValue: "按钮",
      group: "内容",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      bindable: true,
      bindSources: ["state", "record"],
      defaultValue: false,
      group: "其他",
    },
    {
      name: "loading",
      label: "加载中",
      type: PropType.BOOLEAN,
      bindable: true,
      defaultValue: false,
      group: "其他",
    },
    {
      name: "danger",
      label: "危险按钮",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "其他",
    },
    {
      name: "block",
      label: "块级按钮",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "其他",
    },
    {
      name: "ghost",
      label: "幽灵按钮",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "其他",
    },
    {
      name: "shape",
      label: "形状",
      type: PropType.ENUM,
      defaultValue: "default",
      options: [
        { label: "默认", value: "default" },
        { label: "圆形", value: "circle" },
        { label: "圆角", value: "round" },
      ],
      group: "基础",
    },
  ],
  defaultProps: {
    type: "primary",
    children: "按钮",
  },
  defaultStyle: {
    fontSize: 14,
    padding: "8px 15px",
  },
  preview: [
    {
      title: "主要按钮",
      props: {
        type: "primary",
        children: "主要按钮",
      },
    },
    {
      title: "危险操作",
      props: {
        danger: true,
        children: "删除",
      },
    },
  ],
  docLinks: [
    {
      title: "Button 文档",
      url: "https://frontend.mishudata.com/uigallery/iframe.html?key=mijadesign-web/components/button",
      source: "mijadesign",
    },
  ],
  npm: {
    package: "@mijadesign/web",
    exportName: "Button",
  },
  snippet: {
    componentName: "Button",
    package: "@mijadesign/web",
    props: { type: "primary", children: "按钮" },
  },
};
